export default __webpack_public_path__ + "static/media/rentview-logo.463536a9.png";